/*
 * Module for viewing and changing the daily kb refresh.  The feature can be enabled or disabled, and the
 * refresh time can be adjusted to occur on the hour at any hour of the day.
 */

define([
  "marionette",
  "messaging/messenger",
  "./kbDailyRefreshView",
  "./kbDailyRefreshModel",
], function (Marionette, Messenger, KbDailyRefreshView) {
  var KbDailyRefreshModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "KbDailyRefresh";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      //get the kb daily refresh model (probably not synced!)
      this.dailyRefreshModel = Messenger.reqres.request("kb:daily:refresh:model");

      Messenger.onSave(function () {
        console.log("saving kb refresh configuration");
        this.dailyRefreshModel.saveModel();
      }, this);

      this.view = new KbDailyRefreshView.kbDailyRefreshView({ model: this.dailyRefreshModel });

      //toggle the daily refresh option based on the boolean value of isChecked
      this.view.on(
        "toggle:daily:refresh",
        function (isChecked) {
          this.dailyRefreshModel.set("dailyRefresh", isChecked);
        },
        this,
      );

      //change the refresh time
      this.view.on(
        "change:refresh:time",
        function (newHourUTC) {
          this.dailyRefreshModel.set("refreshHourUTC", newHourUTC);
        },
        this,
      );

      this.showRegion(this.view, { loading: true, entity: this.dailyRefreshModel });
    },
    _setUpVents: function () {
      //show the module
      Messenger.vent.on(
        "show:kb:admin:dailyRefresh",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:profile:dailyRefresh",
        function () {
          this.show();
        },
        this,
      );
    },
  });

  return KbDailyRefreshModule;
});
